import styled from 'styled-components'

export const Container = styled.div`
	padding: 2rem 6rem;
	min-height: 63vh;

	@media (max-width: 600px) {
		padding: 1rem;
	}

	@media (max-width: 440px) {
		padding: 1rem 0;
	}
`
